import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxHero from '../features/parallax-hero';

register('hero', parallaxHero);
